import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { HorizontalGuttersTitle } from "../../../Constants/Constants";
import { HorizontalGuttersSubTitle } from "../../../Data/UiKits/Grid";
import { dynamicNumber } from "../../../Utils";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const HorizontalGutters = () => {
  return (
    <Col xl="7">
      <Card className="height-equal">
        <CommonCardHeader title={HorizontalGuttersTitle} span={HorizontalGuttersSubTitle} />
        <CardBody className="h-gutter">
          <Container className="px-4 text-center">
            <Row className="gx-5 gy-sm-0 g-3">
              {dynamicNumber(2).map((item, index) => (
                <Col>
                  <div className="p-3">
                    <span>Custom column padding</span>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </CardBody>
      </Card>
    </Col>
  );
};

export default HorizontalGutters;
